<ul>
    <ng-container *ngFor="let item of items">
        <li *ngIf="!item.subRegions; else branch" 
            tabIndex="0"
            [ngClass]="{ '_bg-primary-1-tint-10 _rounded-md search-criteria-selected-region': selectedRegion == item.name }"
            class="_pl-2 _mb-1 focus:_bg-primary-1-tint-10 _cursor-pointer hover:_bg-primary-1-tint-10"
            (keyup.enter)="regionSelection.next(item)"
            (click)="regionSelection.next(item)">
                {{item.name}}
        </li>
        <ng-template #branch>
            <li class="_font-bold _mt-4 _mb-2">{{item.name}}</li>
            <app-menu-panel 
                [items]="item.subRegions"
                [selectedRegion]="selectedRegion"
                (regionSelection)="regionSelection.next($event)">
            </app-menu-panel>
        </ng-template>
    </ng-container>
</ul>
